import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../theme/tokens';
import Reveal from './Reveal';

type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  lede?: string;
  align?: 'left' | 'center';
  as?: 'h1' | 'h2' | 'h3';
  mb?: number | { xs: number; md: number };
};

const SectionHeading: React.FC<SectionHeadingProps> = ({
  eyebrow,
  title,
  lede,
  align = 'left',
  as = 'h2',
  mb = { xs: 5, md: 7 },
}) => (
  <Reveal>
    <Box
      sx={{
        textAlign: align,
        mb,
        maxWidth: align === 'center' ? 720 : 640,
        mx: align === 'center' ? 'auto' : 0,
      }}
    >
      {eyebrow && (
        <Typography variant="overline" component="p" sx={{ color: colors.accent, mb: 1.5 }}>
          {eyebrow}
        </Typography>
      )}
      <Typography
        component={as}
        variant="h2"
        sx={{ color: colors.text, fontSize: { xs: '2rem', sm: '2.4rem', md: '2.9rem' } }}
      >
        {title}
      </Typography>
      {lede && (
        <Typography sx={{ color: colors.textMuted, mt: 2, fontSize: { xs: '1rem', md: '1.1rem' } }}>
          {lede}
        </Typography>
      )}
    </Box>
  </Reveal>
);

export default SectionHeading;
